var ElcServiceBus;
var ServiceBusTopics;
var generic;
var site;

ElcServiceBus || window.ElcServiceBus;
ServiceBusTopics = ServiceBusTopics || window.ServiceBusTopics;
generic = generic || {};
site = window.site || {};

(function ($) {
  Drupal.behaviors.productContentGridV1 = {
    productHTML: '',
    isMobile: false,
    backOrderEnabled: Drupal.settings.elc_ecom.prodcatConfig.backorder.enabled,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-product-content-grid', context);

      self.isMobile = site.client.isMobile;
      $(document).on('click', function (e) {
        if ($(e.target).closest('.menu-active').length > 0) {
          return;
        }
        $modules
          .find('.js-product-content-grid-filter-menu')
          .removeClass('menu-active');
      });

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.getProps($module);
        self.setInits($module);
        self.setListeners($module);
      });
    },
    getDom: function ($module) {
      $module.nodes = {
        container: $module.find('.js-product-content-grid-container'),
        contents: $module.find('.js-product-content-grid-content'),
        placeholder: $module.find(
          '.js-product-content-grid-filter-placeholder'
        ),
        filterMenu: $module.find('.js-product-content-grid-filter-menu'),
        filterItems: $module.find('.js-product-content-filter-item'),
        filterList: $module.find('.js-product-content-grid-filter-list'),
        products: null,
        skus: null,
        atb: null,
        price: null
      };
    },
    getProps: function ($module) {
      var self = this;

      $module.props = {};
      $module.props.contentOneIndex = $module.data('contentOneIndex')
        ? parseInt($module.data('contentOneIndex'), 10)
        : 1;
      $module.props.allProductIds = self.getOrderProductsByCategory($module);
      $module.props.singularProductCodes = [... new Set($module.props.allProductIds)];
    },
    getOrderProductsByCategory: function ($module) {
      var $filterItem;
      var products = [];

      $module.nodes.filterItems.each(function () {
        $filterItem = $(this);
        $.merge(products, $filterItem.data('productIds').split(','));
      });

      return products;
    },
    getSlidesToShow: function ($skus, breakpoint) {
      var self = this;
      const defaultCounts = {
        mobile: 3,
        1024: 7,
        875: 6,
        768: 5,
        default: 8
      };
      const skuSizeCounts = {
        mobile: 1,
        1024: 3,
        875: 2,
        768: 2,
        default: 3
      };

      if ($skus.data('singleSize')) {
        return 1;
      }

      return $skus.hasClass('sku-sizes')
        ? self.isMobile
          ? skuSizeCounts.mobile
          : skuSizeCounts[breakpoint] || skuSizeCounts.default
        : self.isMobile
          ? defaultCounts.mobile
          : defaultCounts[breakpoint] || defaultCounts.default;
    },
    getSlidesToMove: function ($skus, breakpoint) {
      var self = this;
      const defaultCounts = {
        mobile: 3,
        1024: 7,
        875: 6,
        768: 5,
        default: 8
      };
      const skuSizeCounts = {
        mobile: 1,
        1024: 1,
        875: 1,
        768: 1,
        default: 1
      };

      if ($skus.data('singleSize')) {
        return 1;
      }

      return $skus.hasClass('sku-sizes')
        ? self.isMobile
          ? skuSizeCounts.mobile
          : skuSizeCounts[breakpoint] || skuSizeCounts.default
        : self.isMobile
          ? defaultCounts.mobile
          : defaultCounts[breakpoint] || defaultCounts.default;
    },
    isCarousel: function ($skus, $sku) {
      var self = this;
      var isCarousel = false;
      var isShade = $skus.hasClass('sku-shades') ? true : false;

      if ($skus.data('singleSize')) {
        isCarousel = true;
      }
      if (self.isMobile) {
        if ((isShade && $sku.length > 3) || (!isShade && $sku.length > 1)) {
          isCarousel = true;
        }
      }
      if (!self.isMobile) {
        if (
          (isShade && $sku.length > 8) ||
          (!isShade && $sku.length > 3)
        ) {
          isCarousel = true;
        }
      }

      return isCarousel;
    },
    onSkuClick: function ($selectedSku) {
      var self = this;

      $selectedSku.nodes.siblings.removeClass('active');
      $selectedSku.addClass('active');
      $selectedSku.nodes.media.eq(0).attr('src', $selectedSku.data('skuMedia'));
      $selectedSku.nodes.message.addClass('hidden');
      $selectedSku.nodes.media
        .eq(1)
        .attr('src', $selectedSku.data('skuMediaAlt'));
      $selectedSku.nodes.skuAtb.attr(
        'data-base-id',
        $selectedSku.data('baseId')
      );
      if ($selectedSku.hasClass('active-true')) {
        $selectedSku.nodes.skuAtb.removeClass('outofstock');
        $selectedSku.nodes.skuAtb.html(site.translations.product.add_to_bag);
        $selectedSku.nodes.message.html('');
      }
      if ($selectedSku.hasClass('outofstock-true')) {
        $selectedSku.nodes.skuAtb.removeClass('outofstock');
        $selectedSku.nodes.skuAtb.html(
          site.translations.elc_product.temp_out_of_stock
        );
        $selectedSku.nodes.message.html(
          site.translations.elc_product.item_is_temp_out_of_stock
        );
        if (!self.backOrderEnabled) {
          $selectedSku.nodes.skuAtb.addClass('outofstock');
        }
        $selectedSku.nodes.message.removeClass('hidden');
      }
      if ($selectedSku.hasClass('soldout-true')) {
        $selectedSku.nodes.skuAtb.addClass('outofstock');
        $selectedSku.nodes.skuAtb.html(
          self.backOrderEnabled
            ? site.translations.product.sold_out
            : site.translations.elc_product.item_is_sold_out
        );
        $selectedSku.nodes.message.html(
          site.translations.elc_product.item_is_sold_out
        );
        $selectedSku.nodes.message.removeClass('hidden');
      }
      $selectedSku.nodes.name.html($selectedSku.data('skuName'));
      $selectedSku.nodes.price.html($selectedSku.data('skuPrice'));
    },
    assignSkuNodes: function ($currentSku) {
      var $parent = $currentSku.closest('.js-product-card-partial');

      $currentSku.nodes = {
        parent: $parent,
        media: $parent.find('.js-product-card-partial-media').find('img'),
        skuAtb: $parent.find('.js-product-card-partial-atb'),
        price: $parent.find('.js-product-card-partial-price'),
        name: $parent.find('.js-product-card-partial-skuname'),
        siblings: $parent.find('.js-product-card-partial-sku'),
        message: $parent.find('.js-product-card-partial-unavailable')
      };
    },
    skuClickInit: function ($skus) {
      var self = this;
      var $sku = $skus.find('.js-product-card-partial-sku');

      $sku.each(function () {
        var $currentSku = $(this);

        self.assignSkuNodes($currentSku);
        $currentSku.off('click');

        $currentSku.once().on('click', function () {
          self.onSkuClick($currentSku);
        });
      });
    },
    generateCarousel: function ($module) {
      var self = this;
      var $skus;
      var $sku;

      $module.nodes.skus = $('.js-product-card-partial-skus', $module);
      $module.nodes.skus.each(function () {
        $skus = $(this);
        $sku = $skus.find('.js-product-card-partial-sku');
        $sku.eq(0).addClass('active');
        if (self.isCarousel($skus, $sku)) {
          $skus.removeClass('no-carousel');
          $skus.on('init', function () {
            self.skuClickInit($skus);
          });
          $skus.slick({
            dots: false,
            arrows: true,
            infinite: false,
            variableWidth: $skus.data('singleSize') ? true : false,
            slidesToScroll: self.getSlidesToMove($skus),
            slidesToShow: self.getSlidesToShow($skus),
            rtl: site.direction.isRTL,
            prevArrow:
              '<button class="product-card-partial__skus-carousel-arrows slide-arrow slick-prev" aria-label="Previous" type="button" style="display: block;"><svg class="icon icon--arrow-left" style="fill:#040a2b;"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow:
              '<button class="product-card-partial__skus-carousel-arrows slide-arrow slick-next" aria-label="Next" type="button" style="display: block;"><svg class="icon icon--arrow-left" style="fill:#040a2b;"><use xlink:href="#arrow-right"></use></svg></button>',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToScroll: self.getSlidesToMove($skus, '1024'),
                  slidesToShow: self.getSlidesToShow($skus, '1024')
                }
              },
              {
                breakpoint: 875,
                settings: {
                  slidesToScroll: self.getSlidesToMove($skus, '875'),
                  slidesToShow: self.getSlidesToShow($skus, '875')
                }
              }
            ]
          });
        } else {
          self.skuClickInit($skus);
        }
      });
    },
    renderProduct: function ($module, renderData) {
      var self = this;
      var $rendered = $(Mustache.render(self.productHTML, renderData));
      var reviews;

      $module.nodes.container.append($rendered);
      reviews = $rendered.find('.js-product-card-partial-ratings-reviews')[0];
      reviews.style.setProperty('--perc', renderData['reviewWidth'] + '%');
    },
    getInventoryStatus: function (sku) {
      var inventoryStatus = {
        active: false,
        outOfStock: false,
        comingSoon: false,
        soldOut: false
      };

      if (sku['inventoryStatus'] === 'Active') {
        inventoryStatus['active'] = true;
      }
      if (sku['inventoryStatus'] === 'Temporarily out of stock') {
        inventoryStatus['outOfStock'] = true;
      }
      if (sku['inventoryStatus'] === 'Coming Soon') {
        inventoryStatus['comingSoon'] = true;
      }
      if (sku['inventoryStatus'] === 'Sold Out') {
        inventoryStatus['soldOut'] = true;
      }

      return inventoryStatus;
    },
    getLabelLength: function (product) {
      var skus = product['skus'];

      skus.forEach((sku) => {
        sku['sizes'].forEach((size) => {
          if (size['value'].length > 15) {
            product['singleSize'] = true;
          }
        });
      });
    },
    getProductSizes: function (skus) {
      var self = this;
      var sizes = [];
      var mediaOption = self.isMobile ? 'large' : 'medium';

      skus.forEach((sku) => {
        sku['sizes'].forEach((size) => {
          var skuObj = {};

          skuObj['value'] = size['value'];
          skuObj['media'] =
            typeof sku['media'] === 'string'
              ? sku['media']
              : sku['media'][mediaOption][0]['src'];
          skuObj['mediaAlt'] =
            typeof sku['media'] === 'string'
              ? sku['media']
              : sku['media'][mediaOption][
                sku['media'][mediaOption].length > 1 ? 1 : 0
              ]['src'];
          skuObj['skuId'] = sku['skuId'];
          skuObj['baseId'] = sku['perlgem']['SKU_BASE_ID'];
          skuObj['price'] = sku['prices'][0]['priceFormatted'];
          skuObj['inventoryStatus'] = self.getInventoryStatus(sku);

          sizes.push(skuObj);
        });
      });

      return sizes;
    },
    getProductShades: function (skus) {
      var self = this;
      var shades = [];
      var mediaOption = self.isMobile ? 'large' : 'medium';

      skus.forEach((sku) => {
        sku['shades'].forEach((shade) => {
          var skuObj;

          if (shade['name'] !== '') {
            skuObj = {};
            skuObj['shade'] = shade;
            skuObj['media'] =
              typeof sku['media'] === 'string'
                ? sku['media']
                : sku['media'][mediaOption][0]['src'];
            skuObj['mediaAlt'] =
              typeof sku['media'] === 'string'
                ? sku['media']
                : sku['media'][mediaOption][
                  sku['media'][mediaOption].length > 1 ? 1 : 0
                ]['src'];
            skuObj['skuId'] = sku['skuId'];
            skuObj['baseId'] = sku['perlgem']['SKU_BASE_ID'];
            skuObj['inventoryStatus'] = self.getInventoryStatus(sku);

            shades.push(skuObj);
          }
        });
      });

      return shades;
    },
    checkDeeplink: function () {
      const searchParams = new URLSearchParams(window.location.search);

      if (
        searchParams.get('toFilter') &&
        searchParams.get('toFilter') === 'true'
      ) {
        $('html, body').animate(
          {
            scrollTop: $('.js-product-content-grid').offset().top - 150
          },
          500
        );
      }
    },
    parseProductData: function ($module, data) {
      var self = this;
      var products;
      var sku;
      var skus;
      var productCount = 0;
      var renderData = {};
      var mediaOption;
      var shades;
      var sizes;

      if (data[0]) {
        products = data[0];
        $module.props.singularProductCodes.forEach((code) => {
          products.forEach((product) => {
            if (product['productId'] === code) {
              renderData = {};
              self.getLabelLength(product);
              mediaOption = self.isMobile ? 'large' : 'medium';
              productCount++;
              skus = product['skus'];
              renderData['product'] = product;
              renderData['occasions'] = product['occasion']
                .map(function (item) {
                  return item['key'];
                })
                .toString();

              if (skus && skus.length > 0) {
                sku = skus[0];
                shades = [];
                shades = self.getProductShades(skus);

                if (shades.length > 0) {
                  renderData['skuListShades'] = shades;
                  renderData['countLabel'] =
                    shades.length > 1 ? 'shades' : 'shade';
                  renderData['sizeCount'] = shades.length;
                  renderData['display'] = shades.length === 0 ? 'hidden' : '';
                } else {
                  sizes = [];
                  sizes = self.getProductSizes(skus);
                  renderData['skuListSizes'] = sizes;
                  renderData['countLabel'] =
                    sizes.length > 1 ? 'sizes' : 'size';
                  renderData['sizeCount'] = sizes.length;
                  renderData['display'] = shades.length === 0 ? 'hidden' : '';
                }
                renderData['skuMedia'] =
                  typeof sku['media'] === 'string'
                    ? sku['media']
                    : sku['media'][mediaOption][0]['src'];

                renderData['skuMediaAlt'] =
                  typeof sku['media'] === 'string'
                    ? sku['media']
                    : sku['media'][mediaOption][
                      sku['media'][mediaOption].length > 1 ? 1 : 0
                    ]['src'];

                renderData['size'] = sku['sizes'][0]
                  ? sku['sizes'][0]['value']
                  : sku['sizes'];
                renderData['reviewWidth'] =
                  (product['reviews']['averageRating'] / 5) * 100;

                if (productCount >= $module.props.contentOneIndex) {
                  renderData['gridOrder'] = productCount + 1;
                }
                if (productCount < $module.props.contentOneIndex) {
                  renderData['gridOrder'] = productCount;
                }
                renderData['atbLabel'] = site.translations.product.add_to_bag;
                renderData['hidden'] = 'hidden';
                if (sku['inventoryStatus'] === 'Sold Out') {
                  // Message
                  renderData['message'] =
                    site.translations.elc_product.item_is_sold_out;
                  // Atb class
                  renderData['atbStatus'] = 'outofstock';
                  // Atb label
                  renderData['atbLabel'] = self.backOrderEnabled
                    ? site.translations.product.sold_out
                    : site.translations.elc_product.item_is_sold_out;
                  renderData['hidden'] = '';
                }

                if (sku['inventoryStatus'] === 'Temporarily out of stock') {
                  // Message
                  renderData['message'] =
                    site.translations.elc_product.item_is_temp_out_of_stock;
                  // Atb class
                  renderData['atbStatus'] = self.backOrderEnabled
                    ? ''
                    : 'outofstock';
                  // Atb label
                  renderData['atbLabel'] =
                    site.translations.elc_product.temp_out_of_stock;
                  renderData['hidden'] = '';
                }

                self.renderProduct($module, renderData);
              }
            }
          });
        });

        $module.nodes.products = $('.js-product-card-partial', $module);
        $module.nodes.atb = $('.js-product-card-partial-atb', $module);
        self.generateCarousel($module);
        $module.nodes.filterItems.eq(0).trigger('click');
        self.toggleFilerPanel($module);
        self.setAtbListener($module);
        self.checkDeeplink($module);
      }
    },
    getProductData: function ($module) {
      var self = this;
      var promises = {};
      var productServiceIsGraphQL =
        Drupal?.settings?.product_service === 'graphql';

      try {
        if (productServiceIsGraphQL) {
          const queryOptions = {
            filterBy: {
              productIds: $module.props.singularProductCodes
            }
          };

          promises.products = ElcServiceBus.query(
            ServiceBusTopics.queries.GET_PRODUCT_DATA,
            queryOptions
          );
        }
        // Requires the promises.products to return data even if not defined.
        Promise.all([promises.products, promises.skus]).then((data) => {
          self.parseProductData($module, data);
        });
      } catch (e) {
        console.error(e);
      }
    },
    setInits: function ($module) {
      var self = this;

      $module.closest('.content').css('position', 'relative');
      $module.nodes.container.addClass(
        self.backOrderEnabled ? '' : 'backorder-unavailable'
      );
      generic.template.get({
        path: '/sites/esteelauder/themes/estee_base/template_api/product_content_grid_v1/_partials/product_card_partial_v1.mustache',
        forceReload: true,
        callback: function (html) {
          self.productHTML = html;
          self.getProductData($module);
        }
      });
    },
    toggleFilerPanel: function ($module) {
      $module.nodes.filterMenu.toggleClass('menu-active');
    },
    carouselsReinit: function ($module) {
      var $product;
      var $slick;

      $module.nodes.products.each(function () {
        $product = $(this);
        $slick = $product.find('.slick-initialized');
        if ($slick.length > 0) {
          $slick.slick('slickGoTo', 0);
          $slick.slick('setPosition');
          $slick
            .find('.slick-slide')
            .eq(0)
            .find('.js-product-card-partial-sku')
            .trigger('click')
            .addClass('active');
        }
      });
    },
    removeClassNames: function ($product) {
      var cl = $product.attr('class').split(' ');
      var found;
      var newcl = [];

      for (var i = 0; i < cl.length; i++) {
        found = cl[i].search(/order-+/);
        if (found) {
          newcl[newcl.length] = cl[i];
        }
      }
      $product.removeClass().addClass(newcl.join(' '));
    },
    orderProductsByCategory: function (productsByCategory, orderedIds) {
      var self = this;
      var orderedArray = [... new Set(orderedIds.split(','))];

      if (orderedArray && orderedArray.length > 0) {
        orderedArray.forEach((id, index) => {
          productsByCategory.forEach(($product) => {
            if (parseInt(id, 10) === parseInt($product.data('productId'), 10)) {
              self.removeClassNames($product);
              $product.addClass('order-' + String(index + 2));
            }
          });
        });
      }
    },
    setListeners: function ($module) {
      var self = this;
      var $filterItem;
      var key;
      var $product;
      var filterList;
      var productsByCategory = [];

      $module.nodes.filterItems.once().on('click', function () {
        $filterItem = $(this);
        key = $filterItem.data('filterKey');
        $module.nodes.products.addClass('hidden');
        self.toggleFilerPanel($module);
        $module.nodes.placeholder.html($filterItem.data('filterLabel'));
        productsByCategory = [];
        $module.nodes.products.each(function () {
          $product = $(this);
          filterList = $product.data('filterList')
            ? $product.data('filterList').split(',')
            : [];
          if (filterList.includes(key)) {
            $product.removeClass('hidden');
            productsByCategory.push($product);
          }
        });
        self.orderProductsByCategory(
          productsByCategory,
          $filterItem.data('productIds')
        );
        setTimeout(function () {
          self.carouselsReinit($module);
        }, 250);
      });

      $module.nodes.placeholder.once().on('click', function () {
        self.toggleFilerPanel($module);
      });
    },
    setAtbListener: function ($module) {
      var payload = {};
      var baseId;

      payload.quantity = 1;
      payload.replenishment = false;
      if ($module.nodes.atb.length > 0) {
        $module.nodes.atb.once().on('click', function () {
          baseId = $(this).data('baseId');
          $(document).trigger('perlgem.cart.addItem', [baseId, payload]);
        });
      }
    },
    onImgSrcError: function (img) {
      img.src = '/media/export/cms/everyday_gifting/placeholder_white.jpg';
    }
  };
})(jQuery);
